module.exports = __webpack_public_path__ + "a0c3aab93b5bd0ef5d9708a84ce6ac32.pdf";